"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isObject = function (obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
};
var isFunction = function (obj) {
    return typeof obj === 'function';
};
var empty = function (obj) {
    if (isObject(obj)) {
        return {};
    }
    else if (Array.isArray(obj)) {
        return [];
    }
};
var keys = function (obj) {
    if (isObject(obj)) {
        return Object.getOwnPropertyNames(obj);
    }
    else {
        return Object.keys(obj);
    }
};
function defineProperties(obj, root) {
    var next = empty(obj);
    var props = keys(obj);
    if (!root) {
        root = next;
    }
    var _loop_1 = function (key) {
        var value = obj[key];
        if (isFunction(value)) {
            Object.defineProperty(next, key, {
                get: function () {
                    return value(root);
                },
                configurable: false
            });
            return "continue";
        }
        if (Array.isArray(value) || isObject(value)) {
            Object.defineProperty(next, key, {
                value: defineProperties(value, root),
                configurable: false
            });
            return "continue";
        }
        Object.defineProperty(next, key, { value: value, configurable: false });
    };
    for (var _i = 0, props_1 = props; _i < props_1.length; _i++) {
        var key = props_1[_i];
        _loop_1(key);
    }
    return next;
}
exports.deepComputed = function (obj) { return defineProperties(obj); };
//# sourceMappingURL=index.js.map